import { render } from "./ActivityXPage.vue?vue&type=template&id=69be148d&ts=true"
import script from "./ActivityXPage.vue?vue&type=script&lang=ts"
export * from "./ActivityXPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__